// Utility function to get the full image URL
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function getImageUrl(url) {
  if (!url) return null;
  
  // If it's already a full URL (Cloudinary, external, etc.), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's a relative URL starting with /api, prepend backend URL
  if (url.startsWith('/api/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // For other relative URLs, prepend backend URL
  if (url.startsWith('/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  return url;
}

export default getImageUrl;
